export default "__VITE_ASSET__DadB3VaT__"